/**
 * QMS Ticket Card Skeleton
 * Loading placeholder for ticket cards
 */

export function QmsTicketCardSkeleton() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse">
      {/* Priority bar and header */}
      <div className="flex items-start gap-3 mb-3">
        {/* Priority indicator */}
        <div className="w-1 h-16 bg-gray-200 rounded-full" />

        <div className="flex-1 space-y-2">
          {/* Title */}
          <div className="h-4 bg-gray-200 rounded w-3/4" />

          {/* Badges row */}
          <div className="flex items-center gap-2">
            <div className="h-5 w-16 bg-gray-200 rounded" />
            <div className="h-5 w-12 bg-gray-200 rounded" />
          </div>
        </div>
      </div>

      {/* Tags and footer */}
      <div className="space-y-2 mt-3 pt-3 border-t border-gray-100">
        {/* Tags */}
        <div className="flex items-center gap-2">
          <div className="h-5 w-14 bg-gray-200 rounded" />
          <div className="h-5 w-18 bg-gray-200 rounded" />
        </div>

        {/* Due date and assignee */}
        <div className="flex items-center justify-between">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-8 w-8 bg-gray-200 rounded-full" />
        </div>
      </div>
    </div>
  );
}
